<template>
    
    <el-container>
        <el-main ref="catalogContent">
            <TaskReview :course-id="courseId" :catalogId="catalogId" :resourceId="resourceId" v-if="(resourceType == 0 || resourceType == 1) && reload "></TaskReview>
            <Video :course-id="courseId" :catalogId="catalogId" :resourceId="resourceId" v-if="resourceType == 2 && reload"></Video>
            <TextPage :course-id="courseId" :catalogId="catalogId" :resourceId="resourceId"  v-if="resourceType == 7 && reload"></TextPage>
            <PDFPage :course-id="courseId" :catalogId="catalogId" :resourceId="resourceId"  v-if="resourceType == 6 && reload"></PDFPage>
            <Discussion :course-id="courseId" :catalogId="catalogId" :resourceId="resourceId"  v-if="resourceType == 4 && reload"></Discussion>
        </el-main>
        <el-aside width="28%" ref="catalogTree"  >
            <template>
            <div>
                <div class="courseList-module" v-for="(course,i) in courseList">
                    <div class="courselist-item">
                        <p class="fl pl10 font14px" >第{{i+1}}章　{{course.name}}</p>
                        <!-- 点击编辑按钮显示编辑输入框 -->
                    </div>
                    <div class="courseList-module2" v-for="(item2, j) in course.nodes">
                        <div  @click="typeof item2.resourceModel!='undefined' ? detail(item2.resourceModel, item2.id):detail"
                             :class="typeof item2.resourceModel!='undefined' ? 'courselist-item showItem hasSource' : 'courselist-item '"
                              @mouseenter="showIcon(i+''+j)" @mouseleave="hideIcon()"
                        >
                            <p class="fl pl30 font14px" >
                                <span class="fl wid37 " style="width: 50px;">课时{{j+1}}</span>
                                <span class="yuan"></span>
                                <span>
                                    <el-tooltip class="item" effect="dark" :content="item2.name" placement="top">
                                        <span>{{item2.name| ellipsis}}</span>
                                    </el-tooltip>
                                </span>
                                
                            </p>
                            <p class="fr ">
                                <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 0"
                                   class="icon-blcu-ceshi1 fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)==current">测试</span></i>
                                <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 1"
                                   class="icon-blcu-zuoye fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">作业</span></i>
                                <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 2"
                                   class="icon-blcu-shipin fr mr20" ><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">视频</span></i>
                                <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 3"
                                   class="icon-blcu-zhibobofangshexiangjitianxianxianxing fr mr20">
                                    <span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(j+''+k)==current">直播</span></i>
                                <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 4"
                                   class="icon-blcu-taolun1 fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">讨论</span></i>
                                <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 5"
                                   class="icon-blcu-wenda fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">问答</span></i>
                                <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 6"
                                   class="icon-blcu-wenben fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">文档</span></i>
                                <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 7"
                                   class="icon-blcu-wenben fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">文本</span></i>
                                <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 8"
                                   class="icon-blcu-ziliao fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">资料</span></i>

                            </p>
                        </div>
                        <div class="courseList-module2" v-for="(item3, k) in item2.nodes">
                            <div  @click="typeof item3.resourceModel!='undefined' ? detail(item3.resourceModel, item3.id):detail"
                                 :class="typeof item3.resourceModel!='undefined' ? 'courselist-item showItem hasSource' : 'courselist-item '"
                                  @mouseenter="showIcon(i+''+j+''+k)" @mouseleave="hideIcon()"
                            >
                                <p class="fl pl30 font14px" style="margin-left: 33px;">
                                    <span class="yuan"></span>
                                    <el-tooltip class="item" effect="dark" :content="item3.name" placement="top">
                                        <span>{{item3.name| ellipsis}}</span>
                                    </el-tooltip>
                                </p>
                                <p class="fr ">
                                  <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 0"
                                     class="icon-blcu-ceshi1 fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)==current">测试</span></i>
                                  <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 1"
                                     class="icon-blcu-zuoye fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">作业</span></i>
                                  <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 2"
                                     class="icon-blcu-shipin fr mr20" ><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">视频</span></i>
                                  <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 3"
                                     class="icon-blcu-zhibobofangshexiangjitianxianxianxing fr mr20">
                                    <span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)==current">直播</span></i>
                                  <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 4"
                                     class="icon-blcu-taolun1 fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">讨论</span></i>
                                  <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 5"
                                     class="icon-blcu-wenda fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">问答</span></i>
                                  <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 6"
                                     class="icon-blcu-wenben fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">文档</span></i>
                                  <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 7"
                                     class="icon-blcu-wenben fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">文本</span></i>
                                  <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 8"
                                     class="icon-blcu-ziliao fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">资料</span></i>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
            </template>
        </el-aside>
    </el-container>
</template>

<script>
    import https from '@/https.js';
    import TaskReview from './TaskReview.vue';
    import Video from './Video.vue';
    import TextPage from './Text.vue';
    import PDFPage from './PDF.vue';
    import Discussion from './Discussion.vue'
    
    export default {
      props: ['courseId', 'catalogId','resourceType', 'resourceId'],
      inject:['clientHeight'],
      components: {
        TaskReview: TaskReview,
        Video: Video,
        TextPage: TextPage,
        PDFPage: PDFPage,
        Discussion: Discussion
      },
        data() {
            return {
                courseList: [],
                courseNum: '-1',
                seen: '',
                current: '',
                reload: true
            };

        },
      watch: {
        'clientHeight': function(val) {
          this.changeCatalog(val);
        },
      },
        methods: {
          changeCatalog(catalogHeight) { //动态修改样式
            this.$refs.catalogTree.$el.style.height = catalogHeight - 300 + 'px';
            this.$refs.catalogContent.$el.style.height = catalogHeight - 300 + 'px';
          },
          detail(resourceModel, id) {
            if(!resourceModel) {
              return;
            }
            let params = {
              courseId: this.courseId,
              catalogId: id,
              resourceType: resourceModel.resourceType,
              resourceId: resourceModel.resourcesId,
              detail: 2
            };
            this.reload= false;
            this.$nextTick(() => {
              this.reload= true;
            });
            this.$emit("detailChanged",params);
          },
          beforeRouteLeave (to, from, next){
            to.meta.keepAlive = true;
            if(this.reload){
              to.meta.keepAlive = false;
            }
            next();
          },
          back() {
            this.$router.go(-1);
          },
          showIcon(index) {
            this.seen = true;
            this.current = index;

          },

          hideIcon(index) {
            this.seen = false;
            this.current = null;
          },
            getKnowledgePoints() {
                let params = {
                    'courseId': this.courseId,
                    'userType': 'M',  //M 管理员
                    'status': 1
                };
                https.fetchPost('/catalog/getCourseCatalog',params ,'json').then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == '200') {
                        this.courseList = data.data.data;
                    } else {
                        this.$message({
                            type: 'info',
                            message: '加载失败'+msg
                        });
                    }
                }).catch(err=>{
                        console.log(err);
                    }
                );
            }
        },
          filters: {
            ellipsis(value) {
              if (!value) return "";
              if (value.length > 5) {
                return value.slice(0, 5) + "...";
              }
              return value;
            }
          },

        created: function() {
            this.getKnowledgePoints();
        }
    };
</script>

<style scoped>
    .hasSource {
        cursor: pointer;
    }
    .shenglue {
        margin: auto;
        width: 30px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
